/* unplugin-vue-components disabled */import { render } from "./SidePanel.vue?vue&type=template&id=fd408014&scoped=true&ts=true"
import script from "./SidePanel.vue?vue&type=script&lang=ts"
export * from "./SidePanel.vue?vue&type=script&lang=ts"

import "./SidePanel.vue?vue&type=style&index=0&id=fd408014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd408014"]])

export default __exports__